import { render, staticRenderFns } from "./TechnicalDetail.vue?vue&type=template&id=64a04d38&scoped=true"
import script from "./TechnicalDetail.vue?vue&type=script&lang=js"
export * from "./TechnicalDetail.vue?vue&type=script&lang=js"
import style0 from "./TechnicalDetail.vue?vue&type=style&index=0&id=64a04d38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a04d38",
  null
  
)

export default component.exports